'use client';

import { c as _c } from "react/compiler-runtime";
import ButtonCommon from '@components/button-common/ButtonCommon';
import Portal from '@components/portal/Portal';
import ROUTES from '@lib/constants/routes';
import { COOKIE_SECURE_FORMA_29680, NEW_COOKIE_FORMA_27885 } from '@lib/flags';
import { handleNewUser } from '@lib/store/slices/UserSlice';
import { CookieStorage } from '@lib/tools/helpers/CookieStorage';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { generateNewUserDate, setCookie } from '@lib/tools/utils';
import { animated, useSpring } from '@react-spring/web';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styles from './CookiePopup.module.scss';
import { CookiePopupNew } from './CookiePopupNew';
const CookiePopupOld = () => {
  const $ = _c(18);
  const {
    isMobile
  } = useViewport();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = generateNewUserDate();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const newUserDate = t0;
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(false);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: 0,
      height: 0
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [windowSize, setWindowSize] = useState(t1);
  const [isMounted, setIsMounted] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsMounted(true);
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };
      window.addEventListener("resize", handleResize);
      setTimeout(() => {
        setToggle(true);
      }, 2000);
      return () => window.removeEventListener("resize", handleResize);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const baseWidth = isMobile ? 375 : 1600;
  const scaledHeight = 134 / baseWidth * windowSize.width;
  const t4 = windowSize.height + 100;
  let t5;
  if ($[4] !== t4) {
    t5 = {
      top: t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = toggle && isMounted ? windowSize.height - scaledHeight : windowSize.height + 100;
  let t7;
  if ($[6] !== t6) {
    t7 = {
      top: t6
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      duration: 800,
      mass: 1,
      tension: 280,
      friction: 120
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t5 || $[10] !== t7) {
    t9 = {
      from: t5,
      to: t7,
      config: t8
    };
    $[9] = t5;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const animatedStyle = useSpring(t9);
  if (!isMounted) {
    return null;
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className={styles.text}>Нажимая на эту кнопку, вы соглашаетесь с нашей <Link href={ROUTES.privacy} rel="noopener noreferrer" target="_blank"><span>политикой конфиденциальности</span></Link> и даёте согласие на обработку персональных данных.</div>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== dispatch) {
    t11 = <ButtonCommon className={styles.btn} handleFuction={() => {
      COOKIE_SECURE_FORMA_29680 ? CookieStorage.set("moments_user", newUserDate) : setCookie("moments_user", newUserDate, 365);
      dispatch(handleNewUser({
        isANewUser: "new",
        value: true
      }));
    }} text={"\u0421\u043E\u0433\u043B\u0430\u0441\u0435\u043D"} />;
    $[13] = dispatch;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== animatedStyle || $[16] !== t11) {
    t12 = <Portal><animated.div data-scroll={true} data-scroll-sticky={true} data-scroll-target="#fixed-target" className={styles.container} style={animatedStyle}>{t10}{t11}</animated.div></Portal>;
    $[15] = animatedStyle;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
};
const CookiePopup = NEW_COOKIE_FORMA_27885 ? CookiePopupNew : CookiePopupOld;
export default CookiePopup;